import { Task, TaskApi } from '../interfaces';

const toDate = (value?: string | null): Date | null =>
  value ? new Date(value) : null;

/**
 * El scheduler no es consistente con el identificador: el listado lo expone
 * como `id` y el resto de los endpoints como `_id`. Si se toma uno solo,
 * activar y eliminar mandan `undefined`. El resto del front trabaja con `id`,
 * por eso todas las respuestas pasan por este adaptador.
 */
export const mapTaskApiToTask = (taskApi: TaskApi): Task => ({
  id: taskApi._id ?? taskApi.id ?? '',
  name: taskApi.name,
  cronExpression: taskApi.cronExpression,
  url: taskApi.url,
  method: taskApi.method,
  headers: taskApi.headers ?? {},
  data: taskApi.data,
  authRequired: Boolean(taskApi.authRequired),
  status: taskApi.status,
  lastRunAt: toDate(taskApi.lastRunAt),
  lastRunStatus: taskApi.lastRunStatus ?? null,
  lastRunHttpCode: taskApi.lastRunHttpCode ?? null,
  nextRunAt: toDate(taskApi.nextRunAt),
  createdAt: toDate(taskApi.createdAt),
  updatedAt: toDate(taskApi.updatedAt),
  deletedAt: toDate(taskApi.deletedAt),
});
